import { AssetManager } from 'components/sharpr/assetManager/AssetManager';

export function PostUnarchiveRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.PostUnarchive', {
		url: '/post/:id/unarchive',
		controllerAs: 'vm',
		controller: PostUnarchiveCtrl,
		templateUrl: '/ng/hub/Post/Unarchive/PostUnarchiveCtrl.html?' + window.BUILD,
		resolve: {
			$style: () => AssetManager.css('/ng/hub/Post/Unarchive/PostUnarchiveCtrl.css'),
			$title: () => 'Unarchive Post',
		},
	});
}

class PostUnarchiveCtrl {
	constructor(Identity, Api, Theme, Cfg, AutoArchive, $q, $timeout, $interval, modal, $stateParams) {
		'ngInject';
		this._handleDefaultArchivePeriods = this._handleDefaultArchivePeriods.bind(this);
		// save injections
		this.postId = $stateParams.id;
		this.Identity = Identity;
		this.Theme = Theme;
		this.Api = Api;
		this.Cfg = Cfg;
		this.AutoArchive = AutoArchive;
		this.$q = $q;
		this.$timeout = $timeout;
		this.$interval = $interval;
		this.modal = modal;
		this.setup();
	}

	setup() {
		this._handleDefaultArchivePeriods();
	}

	_handleDefaultArchivePeriods() {
		const allowedPeriodsString = this.Cfg.read('PostArchive.allowed_periods');
		const archivePreset = this.AutoArchive.getArchiveDropdown(allowedPeriodsString);
		const defaultPeriod = this.Cfg.read('PostArchive.default_period');
		if (defaultPeriod) {
			this.archive_selection = defaultPeriod;
		} else {
			this.archive_selection = 'never';
		}
		this.archivePreset = archivePreset;
	}

	onBeforeModalExit() {
		if (!this.isSaving) {
			return this.modal.confirm({
				text: 'You have unsaved changes.',
				confirmText: 'Discard',
				cancelText: 'Continue Editing',
			});
		}
	}

	unarchive() {
		this.patch().then(() => {
			try {
				// handle callbacks from cake pages that pop up edit screen (e.g. story edit page)
				const [$0, callback] = window.location.href.match(/[?&]callback=rintel\.(\w+)/);
				window.parent.rintel[callback]();
			} catch (e) {}
			this.closeModal();
		});
	}

	closeModal() {
		if (this.$reject) {
			// from angular
			this.$reject();
			return;
		}
		try {
			// from cake (e.g. story edit page)
			window.parent.$.RiModal.get('top').close();
		} catch (e) {}
	}

	patch() {
		this.isSaving = true;
		const archiveData = this.AutoArchive.getDateAndActionFromArchiveSelection(this.archive_selection);
		return this.Api.post(`/v2/posts/${this.postId}/unarchive`, archiveData).then(
			() => {},
			() => (this.isSaving = false)
		);
	}
}
